
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-we-help/property-owners",
      function () {
        return require("private-next-pages/who-we-help/property-owners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-we-help/property-owners"])
      });
    }
  